import { render } from "./PwResolution.vue?vue&type=template&id=07c0b2ec"
import script from "./PwResolution.vue?vue&type=script&lang=js"
export * from "./PwResolution.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__